"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.bradford.description': '英国叙述者，富有表现力和吸引力。',
};
